/*
 * Copyright (c) 2022
 * 
 * Created Date: Monday, September 26th 2022, 11:33:17 am
 * Author: Muhammad Fajariansyah Ismail
 * 
 */

import LanguageAtom from "store/routes/languageAtom"
import LocalStorageUtils from "utils/LocalStorage"
import en from 'date-fns/locale/en-US'
import id from 'date-fns/locale/id'
import moment from "moment/moment"
import { LanguageConst } from "utils/Language"
import { registerLocale } from "react-datepicker"
import { useAtom } from "jotai"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"

/**
 * 
 * @returns UseLanguageHooks
 */
const useLanguageHooks = () => {
    const { t, i18n } = useTranslation()
    const [defaultLanguage, setDefaultLanguage] = useAtom(LanguageAtom.language)
    const [defaultDateLocale, setDefaultDateLocale] = useAtom(LanguageAtom.dateLocale)

    useEffect(() => {
        const localStorageLanguage = LocalStorageUtils.language.get()
        if (localStorageLanguage) {
            i18n.changeLanguage(localStorageLanguage)
            setDefaultLanguage(localStorageLanguage)
        }
    }, [])

    /**
     * @typedef {Object} ChangeLanguage
     * @property {Function} toEnglish
     * @property {Function} toIndonesian
     */
    const ChangeLanguage = {
        toEnglish: () => {
            i18n.changeLanguage(LanguageConst.EN)
            setDefaultLanguage(LanguageConst.EN)
            LocalStorageUtils.language.set(LanguageConst.EN)
            moment.locale(LanguageConst.EN)
            setDefaultDateLocale(en)
            registerLocale(en)
        },
        toIndonesian: () => {
            i18n.changeLanguage(LanguageConst.ID)
            setDefaultLanguage(LanguageConst.ID)
            LocalStorageUtils.language.set(LanguageConst.ID)
            moment.locale(LanguageConst.ID)
            setDefaultDateLocale(id)
            registerLocale(id)
        }
    }

    return {
        t,
        defaultLanguage,
        defaultDateLocale,
        ChangeLanguage
    }
}

export default useLanguageHooks
